<template>
    <div>
      <h2>اختر شهرًا لعرض الشيكات:</h2>
      <div class="slider-container">
        <button @click="prevSlide" class="slider-btn">❮</button>
        <div class="slider" ref="slider">
          <div v-for="(month, index) in monthsList" :key="index"
               @click="fetchChecksForMonth(month)"
               :class="{'selected-month': selectedMonth === month}"
               class="month">
            {{ formatISODateWithMonth(month) }}
          </div>
        </div>
        <button @click="nextSlide" class="slider-btn">❯</button>
      </div>
  
      <h3>الشيكات لشهر: {{ selectedMonth ? formatISODateWithMonth(selectedMonth) : 'لم يتم الاختيار بعد' }}</h3>
      <ul>
        <li v-for="check in checks" :key="check.id">
          {{ check.amount }} - {{ formatDate(check.date) }}
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  import firebase from "firebase/app";
  import "firebase/firestore";
  
  export default {
    data() {
      return {
        selectedMonth: null,
        monthsList: [],
        checks: [
        amount = 10,
        date = '02-02-2025'
        ]
        
      };
    },
    mounted() {
      this.generateMonths();
    },
    methods: {
      generateMonths() {
        const today = new Date();
        const currentYear = today.getFullYear();
        for (let yearOffset = -1; yearOffset <= 1; yearOffset++) {
          const year = currentYear + yearOffset;
          for (let i = 0; i < 12; i++) {
            this.monthsList.push(new Date(year, i, 1));
          }
        }
      },
      async fetchChecksForMonth(month) {
        this.selectedMonth = month;
        const year = month.getFullYear();
        const monthNumber = month.getMonth() + 1;
        this.checks = await this.getChecksForMonth(year, monthNumber);
      },
      async getChecksForMonth(year, month) {
        const db = firebase.firestore();
        const startDate = new Date(year, month - 1, 1);
        const endDate = new Date(year, month, 0, 23, 59, 59);
        
        try {
          const checksRef = db.collection("cheques");
          const querySnapshot = await checksRef
            .where("date", ">=", firebase.firestore.Timestamp.fromDate(startDate))
            .where("date", "<=", firebase.firestore.Timestamp.fromDate(endDate))
            .get();
  
          let checks = [];
          querySnapshot.forEach(doc => {
            checks.push({ id: doc.id, ...doc.data() });
          });
  
          return checks;
        } catch (error) {
          console.error("خطأ في جلب الشيكات:", error);
          return [];
        }
      },
      nextSlide() {
        this.$refs.slider.scrollBy({ left: 150, behavior: 'smooth' });
      },
      prevSlide() {
        this.$refs.slider.scrollBy({ left: -150, behavior: 'smooth' });
      },
      formatISODateWithMonth(date) {
        const months = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
        const monthName = months[date.getMonth()];
        return `${monthName} - ${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      },
      formatDate(timestamp) {
        if (!timestamp) return "تاريخ غير متوفر";
        const date = timestamp.toDate();
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      }
    }
  };
  </script>
  
  <style>
  .slider-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    overflow: hidden;
    position: relative;
  }
  
  .slider {
    display: flex;
    overflow: hidden;
    scroll-behavior: smooth;
    white-space: nowrap;
    width: 300px;
    padding: 10px;
  }
  
  .month {
    display: inline-block;
    padding: 10px 20px;
    margin: 5px;
    background-color: #f0f0f0;
    border: 1px solid #ddd;
    cursor: pointer;
    border-radius: 8px;
    transition: background-color 0.3s, color 0.3s;
    flex: 0 0 auto;
  }
  
  .month:hover {
    background-color: #e0e0e0;
  }
  
  .selected-month {
    background-color: #4caf50;
    color: white;
    font-weight: bold;
  }
  
  .slider-btn {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    padding: 5px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/CheckList.vue